var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95427 5.36001H7.40927V1.76001C7.40927 0.92001 6.95427 0.75001 6.39927 1.38001L5.99927 1.83501L2.61427 5.68501C2.14927 6.21001 2.34427 6.64001 3.04427 6.64001H4.58927V10.24C4.58927 11.08 5.04427 11.25 5.59927 10.62L5.99927 10.165L9.38427 6.31501C9.84927 5.79001 9.65427 5.36001 8.95427 5.36001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.8cc244158d0ecc4e4493e410420229b8.svg";
export { ForwardRef as ReactComponent };